<div style="padding: 20px;">
    <h2>Activity Timeline with Daily Threshold Breach</h2>
    <div echarts class="echarts" [options]="chartOption"></div>
</div>